import { SET_OFFLINE_FILES, SET_CREATED_OFFLINE_FILES } from '../constants/ActionTypes'

/**
 * @typedef {import('../types/system').OfflineFilesEntry} OfflineFilesEntry
 * @typedef {import('../types/system').KnownFilesEntry} KnownFilesEntry
 * @typedef {import('../types/system').CreatedOfflineFileEntry} CreatedOfflineFileEntry
 */

/**
 * @typedef {ReturnType<typeof setOfflineFiles> | ReturnType<typeof setCreatedOfflineFiles>} OfflineActions
 */

/**
 * @param {Record<String, OfflineFilesEntry>} offlineFiles
 * @return {{ type: 'SET_OFFLINE_FILES', offlineFiles: Array<OfflineFilesEntry> }}
 */
export const setOfflineFiles = (offlineFiles) => {
  return {
    type: SET_OFFLINE_FILES,
    offlineFiles: Object.values(offlineFiles),
  }
}

/**
 * @param {Record<String, CreatedOfflineFileEntry>} createdOfflineFiles
 * @return {{ type: 'SET_CREATED_OFFLINE_FILES', createdOfflineFiles: Array<CreatedOfflineFileEntry> }}
 */
export const setCreatedOfflineFiles = (createdOfflineFiles) => {
  return {
    type: SET_CREATED_OFFLINE_FILES,
    createdOfflineFiles: Object.values(createdOfflineFiles),
  }
}
